<script lang="ts">
import { modalRegister } from '../modals/ModalStack.vue';
import AlertModal from './AlertModal.vue';

export function alertModal({
  title,
  message = '',
  messageClass = '',
  dangerouslySetInnerHtml = '',
  actionDefaultText = 'OK',
  actionDefaultVariant = 'default',
  actionCancelText = '',
}: {
  title: string;
  message?: string;
  messageClass?: string;
  dangerouslySetInnerHtml?: string;
  actionDefaultText?: string;
  actionDefaultVariant?: 'default' | 'destructive';
  actionCancelText?: string;
}): Promise<true | null> {
  return modalRegister(AlertModal, {
    title,
    message,
    messageClass,
    dangerouslySetInnerHtml,
    actionDefaultText,
    actionDefaultValue: true,
    actionDefaultVariant,
    actionCancelText,
  });
}
</script>

<script setup lang="ts">
import { Button } from '../button';

defineProps<{
  title: string;
  message: string;
  messageClass: string;
  dangerouslySetInnerHtml: string;
  actionDefaultText: string;
  actionDefaultValue: unknown;
  actionDefaultVariant: 'default' | 'destructive';
  actionCancelText: string;
}>();

defineEmits<{ modalClose: [unknown] }>();
</script>

<template>
  <div class="flex flex-col gap-4">
    <div class="flex flex-col gap-y-3 text-center sm:text-left">
      <h2 class="text-lg font-semibold text-slate-900">{{ title }}</h2>
      <div
        v-if="dangerouslySetInnerHtml"
        class="prose prose-sm max-w-none text-sm leading-relaxed text-slate-700"
        v-html="dangerouslySetInnerHtml"
      ></div>
      <div v-else class="prose prose-sm max-w-none text-sm leading-relaxed text-slate-700" :class="messageClass">
        {{ message }}
      </div>
    </div>
    <form method="dialog" class="flex flex-col-reverse sm:flex-row sm:justify-end sm:gap-x-2">
      <Button v-if="actionCancelText" type="submit" variant="outline">{{ actionCancelText }}</Button>
      <Button type="button" :variant="actionDefaultVariant" @click="$emit('modalClose', actionDefaultValue)">
        {{ actionDefaultText }}
      </Button>
    </form>
  </div>
</template>
